const CartCalculationResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'offers/',
        apiRequestParams.defaults(),
        {
            calculate: {
                url: appConfig.apiBaseUrl + 'cartcalculations',
                method: 'POST',
            },
        }
    );
};

module.exports = CartCalculationResource;
